function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { convertToGAIndex, sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
var EVENT_CATEGORY = 'Navigation - mobile menu';
var itemToPathItem = function itemToPathItem(item) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    title: item.title,
    level: item.level,
    index
  };
};
export var findPathToItem = function findPathToItem(navigationData, targetItem) {
  var loop = function loop(path, item, index) {
    return targetItem === item ? [[].concat(_toConsumableArray(path), [itemToPathItem(targetItem, index)])] : item.items.reduce(function (acc, child, thisIndex) {
      return acc.concat(loop([].concat(_toConsumableArray(path), [itemToPathItem(item, index)]), child, thisIndex));
    }, []);
  };
  return loop([], navigationData)[0].slice(1);
};
var buildEventLabelSegment = function buildEventLabelSegment(pathItem) {
  return [pathItem.level, convertToGAIndex(pathItem.index), pathItem.title].join('|');
};
var buildEventLabel = function buildEventLabel(navigationData, targetItem) {
  return findPathToItem(navigationData, targetItem).map(buildEventLabelSegment).join('|');
};
export var selectItem = function selectItem(navigationData, item) {
  sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Select',
    event_label: buildEventLabel(navigationData, item)
  });
};
export var clickLink = function clickLink(evt, navigationData, item) {
  sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Click',
    event_label: buildEventLabel(navigationData, item),
    destination_URL: item.url
  });
};
export var back = function back(level) {
  sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Back',
    event_label: "Back to level ".concat(convertToGAIndex(level))
  });
};